import { useEffect, useState, useMemo } from 'react';
import { getAllUsers } from '../../../api/adminAPI';
import { useAdminAPI } from './useAdminAPI';

export interface User {
    userId: number;
    name: string;
    username: string;
    role: string;
    isSlideDownYN: boolean;
    isWithdrawnYN: boolean;
    email?: string;
    birthDate?: string;
    phone?: string;
    workplace?: string;
    medicalLicenseNumber?: string | null;
    department?: string | null;
    position?: string | null;
    isSpecialist?: boolean | null;
    specialistNumber?: string | null;
    [key: string]: any;
}

interface UsersResponse {
    resultCode: string;
    message: string;
    data: User[];
}

/**
 * 사용자 목록 조회를 위한 커스텀 훅
 *
 * @returns users, loading, error, refetch, setSearchKeyword
 */
export const useUsers = () => {
    const { data, loading, error, execute, refetch } = useAdminAPI<UsersResponse>(getAllUsers);
    const [searchKeyword, setSearchKeyword] = useState('');

    useEffect(() => {
        execute();
    }, []);

    const filteredUsers = useMemo(() => {
        const allUsers = data?.data || [];
        if (!searchKeyword.trim()) return allUsers;

        const lowerKeyword = searchKeyword.toLowerCase();

        return allUsers.filter(user =>
            user.username.toLowerCase().includes(lowerKeyword) ||
            user.name.toLowerCase().includes(lowerKeyword) ||
            (user.email?.toLowerCase().includes(lowerKeyword) ?? false) ||
            (user.workplace?.toLowerCase().includes(lowerKeyword) ?? false) ||
            (user.phone?.includes(lowerKeyword) ?? false)
        );
    }, [data?.data, searchKeyword]);

    return {
        users: filteredUsers,
        loading,
        error,
        refetch,
        setSearchKeyword,
    };
};